import { FC } from 'react';

import { Banner as BannerData } from 'utils/banner/utils';
import { Campaign } from 'utils/campaign';

import { Card, VSpacing } from '@hh.ru/magritte-ui';

import { BannerActions } from 'components/Banners/components/Banner/components/BannerActions/BannerActions';
import { BannerInfo } from 'components/Banners/components/Banner/components/BannerInfo/BannerInfo';
import { BannerModeration } from 'components/Banners/components/Banner/components/BannerModeration/BannerModeration';
import { BannerStatisticsCard } from 'components/Banners/components/Banner/components/BannerStatisticsCard/BannerStatisticsCard';

interface BannerProps {
    campaign: Campaign;
    banner: BannerData;
    hasOnlyOneEnabledBanner: boolean;
    singleBanner: boolean;
}

export const Banner: FC<BannerProps> = ({ campaign, banner, hasOnlyOneEnabledBanner, singleBanner }) => {
    const {
        id: bannerId,
        title,
        text,
        url,
        imageUrl,
        videoThumbnailUrl,
        enabled,
        moderationStatus,
        statistics,
        createdAt,
        states,
        bannedAsAdvertisement,
        bannedForAllSources,
    } = banner;

    const { id: campaignId, campaignSources, frontendStatus, advertisingServiceType } = campaign;
    const sources = campaignSources.map((source) => source.apiSource);

    return (
        <>
            <Card stretched borderRadius={24} borderWidth="default" direction="column">
                <BannerInfo
                    title={title}
                    text={text}
                    url={url}
                    imageUrl={imageUrl}
                    videoThumbnailUrl={videoThumbnailUrl}
                    enabled={enabled}
                    moderationStatus={moderationStatus}
                    states={states}
                    advertisingServiceType={advertisingServiceType}
                    campaignStatus={frontendStatus}
                />
                <Card.Between />
                <BannerStatisticsCard statistics={statistics} createdAt={createdAt} sources={sources} />
                <BannerModeration
                    enabled={enabled}
                    bannedAsAdvertisement={bannedAsAdvertisement}
                    bannedForAllSources={bannedForAllSources}
                    singleBanner={singleBanner}
                    states={states}
                />
                <BannerActions
                    bannerId={bannerId}
                    campaignId={campaignId ?? 0}
                    enabled={enabled}
                    campaignStatus={frontendStatus}
                    advertisingServiceType={advertisingServiceType}
                    shows={statistics.shows}
                    hasOnlyOneEnabledBanner={hasOnlyOneEnabledBanner}
                    singleBanner={singleBanner}
                />
            </Card>
            <VSpacing default={24} />
        </>
    );
};
